import { BUCKETS, BUCKET_LABEL, fmtCompact as fmt } from "./utils";

export function AgingBar({ overdueSummary, bucketFilter, setBucketFilter }) {
  if (!overdueSummary?.buckets || overdueSummary.total <= 0) return null;
  return (
    <div className="mb-4 border border-border rounded-lg overflow-hidden" data-testid="aging-buckets">
      <div className="px-4 py-2 text-[10px] uppercase tracking-[0.2em] font-semibold text-muted-foreground flex items-center justify-between bg-muted/40 border-b border-border">
        <span>Aging buckets</span>
        <span className="text-primary">{fmt(overdueSummary.total)} · {overdueSummary.invoice_count} invoice(s)</span>
      </div>
      <div className="p-3 space-y-2">
        <div className="flex h-3 rounded-full overflow-hidden bg-muted">
          {BUCKETS.map((b) => {
            const bucket = overdueSummary.buckets[b.key];
            const pct = overdueSummary.total > 0 ? (bucket.total / overdueSummary.total) * 100 : 0;
            if (pct === 0) return null;
            const active = bucketFilter === b.key;
            return (
              <button type="button" key={b.key}
                      onClick={() => setBucketFilter(active ? "all" : b.key)}
                      className={`${b.color} transition-opacity ${bucketFilter !== "all" && !active ? "opacity-40" : ""} hover:opacity-100`}
                      style={{ width: `${pct}%` }}
                      title={`${b.label}: ${bucket.count} invoice(s) · ${fmt(bucket.total)}`}
                      data-testid={`aging-bar-${b.key}`} />
            );
          })}
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-[11px]">
          {BUCKETS.map((b) => {
            const bucket = overdueSummary.buckets[b.key];
            const active = bucketFilter === b.key;
            return (
              <button type="button" key={b.key} onClick={() => setBucketFilter(active ? "all" : b.key)}
                      className={`flex items-center gap-2 rounded px-2 py-1 transition-colors ${active ? "bg-primary/10 text-primary" : "hover:bg-muted/60"}`}
                      data-testid={`aging-legend-${b.key}`}>
                <span className={`w-2 h-2 rounded-full ${b.color}`} />
                <span className={active ? "font-medium" : "text-muted-foreground"}>{b.label}</span>
                <span className="ml-auto font-medium">{bucket.count} · {fmt(bucket.total)}</span>
              </button>
            );
          })}
        </div>
        {bucketFilter !== "all" && (
          <div className="text-[11px] text-muted-foreground flex items-center gap-2" data-testid="bucket-filter-active">
            Filtering owners to <span className="font-medium text-foreground">{BUCKET_LABEL[bucketFilter]} days</span>
            <button type="button" onClick={() => setBucketFilter("all")} className="text-primary hover:underline" data-testid="bucket-filter-clear">Clear</button>
          </div>
        )}
      </div>
    </div>
  );
}
